export const programFragment = `
  id: _id
  programName
`;
